import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetsService, PanelItemAssetVM } from '../../infrastructure/services/assets.service';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';
import { ParametrosService, Sx_Configuration } from '../../infrastructure/services/parametros.service';

@Component({
  templateUrl: 'parametros.listado.component.html'
})
export class ParametrosListadoComponent implements OnInit {
  mostarAddButton = true;
  mostrarForm = false;
  parametros: Sx_Configuration[];
  preguntarSiDeseaBorrar = [];
  parametroSeleccionado: Sx_Configuration;

  constructor(private router: Router,
    private aRoute: ActivatedRoute,
              private alertService: AlertService,
              private parametrosService: ParametrosService) { }

  ngOnInit() {
    this.obtenerListado();
  }

  eliminar(key: string) {
    this.parametrosService.eliminar(key)
      .then(eliminado => {
        this.alertService.showGrowl({
          body: `ELIMINADO_OK`,
          type: GrowlType.SUCCESS
        });

        // Busco el asset de la lista que corresponde con el parametro borrado
        // y lo elimino
        const index = this.parametros.findIndex(parametro => parametro.key === key);
        this.parametros.splice(index, 1);
      });
  }

  obtenerListado() {
    this.parametrosService.getAll()
      .then(listado => this.parametros = listado);
  }
  
  editar(parametro) {
    this.parametroSeleccionado = parametro;
    this.mostrarForm = true;
    this.mostarAddButton = false;
  }

  clickEnAdd() {
    this.parametroSeleccionado = null;
    this.mostarAddButton = false;
    this.mostrarForm = true;
  }

  onCancelForm() {
    this.parametroSeleccionado = null;
    this.mostarAddButton = true;
    this.mostrarForm = false;
  }

  onSaveForm() {
    this.parametroSeleccionado = null;
    this.mostarAddButton = true;
    this.mostrarForm = false;
    this.alertService.showGrowl({
      body: `CREADO_OK`,
      type: GrowlType.SUCCESS
    });
    this.obtenerListado();
  }
  volver() {
      this.router.navigate(['../'], { relativeTo: this.aRoute });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/parametros/parametros.listado.component.ts